import React from 'react';
import styled from 'styled-components';

import { Flex, Loading, Typography } from 'components';
import { useDownloads } from 'features/downloads';
import { Icon } from 'components/icon';

const IconFile = styled(Icon)`
  width: 32px;
  color: ${({ theme }) => theme.colors.gray_600};
`;

const IconDownload = styled(Icon)`
  width: 32px;
`;

const Wrapper = styled.a`
  display: flex;
  width: 100%;
  margin: 0 auto;
  border: 1px solid ${({ theme }) => theme.colors.gray_600};
  border-radius: 4px;
  justify-content: space-between;
  align-items: center;

  ${({ theme: { mediaQueries } }) => {
    return `
      ${mediaQueries.desktop} {
        max-width: 780px;
      }
    `;
  }}

  &:hover {
    background: ${({ theme }) => theme.colors.dark_400};
  }
`;

const Downloads = () => {
  const { downloads, getDownload, downloading, downloadingPercentage } = useDownloads();

  if (!downloads?.length) return <></>;

  return (
    <>
      {downloading && <Loading alpha label={`Por favor, aguarde.<br />${downloadingPercentage ? `${downloadingPercentage}%` : ``}`} />}

      <Flex mt={{ d: 80 }}>
        {downloads.map((download, index) => {
          return (
            <React.Fragment key={`download-box-${index.toString()}`}>
              {download.downloadType === 0 && (
                <Wrapper href={download.downloadUrl} target="_blank">
                  <Flex flexGrow={0} alignItems="center" py={20}>
                    <Flex flexGrow={0} px={{ d: 25 }}>
                      <IconFile icon="fileDocumentOutline" />
                    </Flex>

                    <Typography type="type3" color="primary_400" fontWeight="bold">
                      {download.name}
                    </Typography>
                  </Flex>

                  <Flex flexGrow={0} px={{ d: 25 }}>
                    <IconDownload icon="download" />
                  </Flex>
                </Wrapper>
              )}

              {(download.downloadType === 1 || download.downloadType === 2) && (
                <Wrapper onClick={() => getDownload(download.downloadUrl, download.downloadFileName)}>
                  <Flex flexGrow={0} alignItems="center" py={20}>
                    <Flex flexGrow={0} px={{ d: 25 }}>
                      <IconFile icon="fileDocumentOutline" />
                    </Flex>

                    <Typography type="type3" color="primary_400" fontWeight="bold">
                      {download.name}
                    </Typography>
                  </Flex>

                  <Flex flexGrow={0} px={{ d: 25 }}>
                    <IconDownload icon="download" />
                  </Flex>
                </Wrapper>
              )}
            </React.Fragment>
          );
        })}
      </Flex>
    </>
  );
};

export default Downloads;
